var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", "max-width": "290" },
      model: {
        value: _vm.showSimilarityDialog,
        callback: function($$v) {
          _vm.showSimilarityDialog = $$v
        },
        expression: "showSimilarityDialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", { staticClass: "headline" }, [
            _vm._v("Similarity Checker")
          ]),
          _vm._v(" "),
          _c("v-card-text", [
            _vm._v("Please type a sentence you want to compare")
          ]),
          _vm._v(" "),
          _c(
            "v-flex",
            [
              _c("v-text-field", {
                model: {
                  value: _vm.keyword1,
                  callback: function($$v) {
                    _vm.keyword1 = $$v
                  },
                  expression: "keyword1"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            [
              _c("v-text-field", {
                model: {
                  value: _vm.keyword2,
                  callback: function($$v) {
                    _vm.keyword2 = $$v
                  },
                  expression: "keyword2"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.theScore !== ""
            ? _c("v-flex", [_c("span", [_vm._v(_vm._s(_vm.theScore))])])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c("div", { staticClass: "flex-grow-1" }),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "green darken-1", text: "" },
                  on: { click: _vm.closeDialog }
                },
                [_vm._v("Cancel")]
              ),
              _vm._v(" "),
              _vm.loading
                ? _c(
                    "v-btn",
                    {
                      attrs: {
                        loading: "",
                        disabled: "",
                        color: "green darken-1",
                        text: ""
                      },
                      on: { click: _vm.checkSimilarity }
                    },
                    [_vm._v("Check")]
                  )
                : _c(
                    "v-btn",
                    {
                      attrs: { color: "green darken-1", text: "" },
                      on: { click: _vm.checkSimilarity }
                    },
                    [_vm._v("Check")]
                  )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-428e6624", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-428e6624","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user-class/similarityDialog.vue
// module id = null
// module chunks = 